// namespace (소문자)
export const NAMESPACE = 'internet';
//actions
export const CREATE_INTERNET_COMMERCE_ESTIMATION =
  'CREATE_INTERNET_COMMERCE_ESTIMATION';
export const SELECT_INTERNET_COMMERCE_ESTIMATION =
  'SELECT_INTERNET_COMMERCE_ESTIMATION';
export const SELECT_INTERNET_COMMERCE_COUPON =
  'SELECT_INTERNET_COMMERCE_COUPON';
export const SELECT_INTERNET_COMMERCE_DETAIL =
  'SELECT_INTERNET_COMMERCE_DETAIL';
export const SELECT_INTERNET_COMMERCE_UUID_DETAIL =
  'SELECT_INTERNET_COMMERCE_UUID_DETAIL';
export const UPDATE_INTERNET_COMMERCE_VISIBLE =
  'UPDATE_INTERNET_COMMERCE_VISIBLE';
export const UPDATE_INTERNET_COMMERCE_CLOSING =
  'UPDATE_INTERNET_COMMERCE_CLOSING';
export const CREATE_INTERNET_COMMERCE_QUOTATION =
  'CREATE_INTERNET_COMMERCE_QUOTATION';
export const SELECT_INTERNET_COMMERCE_OWNER_QUOTATION =
  'SELECT_INTERNET_COMMERCE_OWNER_QUOTATION';
export const SELECT_INTERNET_COMMERCE_QUOTATION_CNT_CHECK =
  'SELECT_INTERNET_COMMERCE_QUOTATION_CNT_CHECK';
export const SELECT_INTERNET_COMMERCE_USER_QUOTATION =
  'SELECT_INTERNET_COMMERCE_USER_QUOTATION';
export const SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW =
  'SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW';
export const CREATE_INTERNET_COMMERCE_APPLY = 'CREATE_INTERNET_COMMERCE_APPLY';
export const SELECT_INTERNET_COMMERCE_APPLY_DETAIL =
  'SELECT_INTERNET_COMMERCE_APPLY_DETAIL';
export const CREATE_INTERNET_COMMERCE_APPLY_SUBMIT =
  'CREATE_INTERNET_COMMERCE_APPLY_SUBMIT';
export const SELECT_INTERNET_COMMERCE_APPLY_LIST =
  'SELECT_INTERNET_COMMERCE_APPLY_LIST';
export const SELECT_OWNER_INTERNET_COMMERCE_APPLY_LIST =
  'SELECT_OWNER_INTERNET_COMMERCE_APPLY_LIST';
export const SELECT_INTERNET_COMMERCE_APPLY_NEW_COUNT =
  'SELECT_INTERNET_COMMERCE_APPLY_NEW_COUNT';
export const SELECT_INTERNET_COMMERCE_FORECAST =
  'SELECT_INTERNET_COMMERCE_FORECAST';
export const CREATE_INTERNET_DIRECT_SUBMIT = 'CREATE_INTERNET_DIRECT_SUBMIT';
export const SELECT_INTERNET_CHAT_QUOTATION_LIST =
  'SELECT_INTERNET_CHAT_QUOTATION_LIST';
export const CREATE_INTERNET_PROMOTION_SUBMIT =
  'CREATE_INTERNET_PROMOTION_SUBMIT';
export const SELECT_INTERNET_PRODUCTS = 'SELECT_INTERNET_PRODUCTS';
export const UPDATE_INTERNET_BOOKMARK = 'UPDATE_INTERNET_BOOKMARK';
export const UPDATE_INTERNET_VIEW_PRODUCT = 'UPDATE_INTERNET_VIEW_PRODUCT';
export const UPDATE_INTERNET_SEL_PRODUCT = 'UPDATE_INTERNET_SEL_PRODUCT';
export const SELECT_INTERNET_APPLY_CHECK_LIMIT =
  'SELECT_INTERNET_APPLY_CHECK_LIMIT';
export const FETCH_INTERNET_COMMERCE_PROMOTION =
  'FETCH_INTERNET_COMMERCE_PROMOTION';
export const FETCH_INTERNET_COMMERCE_PROMOTION_DETAIL =
  'FETCH_INTERNET_COMMERCE_PROMOTION_DETAIL';
export const FETCH_INTERNET_COMMERCE_PROMOTION_SUPPORT =
  'FETCH_INTERNET_COMMERCE_PROMOTION_SUPPORT';
export const SELECT_INTERNET_APPLY_VALIDATE = 'SELECT_INTERNET_APPLY_VALIDATE';
export const SELECT_INTERNET_APPLY_CHECK_VALIDATE =
  'SELECT_INTERNET_APPLY_CHECK_VALIDATE';
export const UPDATE_INTERNET_COMMERCE_PROMOTION_CHAT =
  'UPDATE_INTERNET_COMMERCE_PROMOTION_CHAT';
export const SET_INTERNET_APPLY_CANCEL = 'SET_INTERNET_APPLY_CANCEL';
export const SELECT_INTERNET_SUPPORT_APPLY_LIST =
  'SELECT_INTERNET_SUPPORT_APPLY_LIST';
export const SELECT_INTERNET_APPLY_LIST_SIMPLE =
  'SELECT_INTERNET_APPLY_LIST_SIMPLE';
export const UPDATE_INTERNET_APPLY_INSTALL_DATE =
  'UPDATE_INTERNET_APPLY_INSTALL_DATE';
export const UPDATE_INTERNET_APPLY_DEPOSIT = 'UPDATE_INTERNET_APPLY_DEPOSIT';
export const SELECT_INTERNET_COMMERCE_INSTALL_COST =
  'SELECT_INTERNET_COMMERCE_INSTALL_COST';
export const SELECT_INTERNET_COMMERCE_ITEMS = 'SELECT_INTERNET_COMMERCE_ITEMS';
export const INSERT_INTERNET_COMMERCE_ITEMS = 'INSERT_INTERNET_COMMERCE_ITEMS';
export const SELECT_INTERNET_COMMERCE_MY_ITEMS =
  'SELECT_INTERNET_COMMERCE_MY_ITEMS';
export const DELETE_INTERNET_COMMERCE_MY_ITEMS =
  'DELETE_INTERNET_COMMERCE_MY_ITEMS';
export const UPDATE_INTERNET_COMMERCE_MY_ITEMS_SORT =
  'UPDATE_INTERNET_COMMERCE_MY_ITEMS_SORT';
export const SELECT_INTERNET_COMMERCE_SAME_COUNT =
  'SELECT_INTERNET_COMMERCE_SAME_COUNT';

//mutations
// export const SET_INTERNET_COMMERCE = 'SET_INTERNET_COMMERCE';
export const SET_INTERNET_COMMERCE_ING_LIST = 'SET_INTERNET_COMMERCE_ING_LIST';
export const SET_INTERNET_COMMERCE_END_LIST = 'SET_INTERNET_COMMERCE_END_LIST';
export const SET_INTERNET_COMMERCE_DETAIL = 'SET_INTERNET_COMMERCE_DETAIL';
export const SET_INTERNET_COMMERCE_USER_QUOTATION_LIST =
  'SET_INTERNET_COMMERCE_USER_QUOTATION_LIST';
export const SET_INTERNET_COMMERCE_USER_QUOTATION_NEW_LIST =
  'SET_INTERNET_COMMERCE_USER_QUOTATION_NEW_LIST';
export const SET_INTERNET_COMMERCE_QUOTATION_ING_LIST =
  'SET_INTERNET_COMMERCE_QUOTATION_ING_LIST';
export const SET_INTERNET_COMMERCE_QUOTATION_END_LIST =
  'SET_INTERNET_COMMERCE_QUOTATION_END_LIST';
export const SET_INTERNET_COMMERCE_QUOTATION_CNT_CHECK =
  'SET_INTERNET_COMMERCE_QUOTATION_CNT_CHECK';
export const SET_INTERNET_COMMERCE_APPLY_DETAIL =
  'SET_INTERNET_COMMERCE_APPLY_DETAIL';
export const SET_INTERNET_COMMERCE_APPLY_LIST =
  'SET_INTERNET_COMMERCE_APPLY_LIST';
export const SET_INTERNET_COMMERCE_APPLY_NEW_COUNT =
  'SET_INTERNET_COMMERCE_APPLY_NEW_COUNT';
export const SET_INTERNET_COMMERCE_FORECAST = 'SET_INTERNET_COMMERCE_FORECAST';
export const SET_INTERNET_CHAT_QUOTATION_LIST =
  'SET_INTERNET_CHAT_QUOTATION_LIST';
export const SELECT_INTERNET_REQUEST_CNT = 'SELECT_INTERNET_REQUEST_CNT';

// //state

// //getters
// export const INTERNET_COMMERCE = 'INTERNET_COMMERCE';
export const INTERNET_COMMERCE_ING_LIST = 'INTERNET_COMMERCE_ING_LIST';
export const INTERNET_COMMERCE_END_LIST = 'INTERNET_COMMERCE_END_LIST';
export const INTERNET_COMMERCE_DETAIL = 'INTERNET_COMMERCE_DETAIL';
export const INTERNET_COMMERCE_USER_QUOTATION =
  'INTERNET_COMMERCE_USER_QUOTATION';
export const INTERNET_COMMERCE_USER_QUOTATION_NEW =
  'INTERNET_COMMERCE_USER_QUOTATION_NEW';
export const INTERNET_COMMERCE_QUOTATION_ING_LIST =
  'INTERNET_COMMERCE_QUOTATION_ING_LIST';
export const INTERNET_COMMERCE_QUOTATION_END_LIST =
  'INTERNET_COMMERCE_QUOTATION_END_LIST';
export const INTERNET_COMMERCE_QUOTATION_CNT_CHECK =
  'INTERNET_COMMERCE_QUOTATION_CNT_CHECK';
export const INTERNET_COMMERCE_APPLY_DETAIL = 'INTERNET_COMMERCE_APPLY_DETAIL';
export const INTERNET_COMMERCE_APPLY_LIST = 'INTERNET_COMMERCE_APPLY_LIST';
export const INTERNET_COMMERCE_APPLY_NEW_COUNT =
  'INTERNET_COMMERCE_APPLY_NEW_COUNT';
export const INTERNET_COMMERCE_FORECAST = 'INTERNET_COMMERCE_FORECAST';
export const INTERNET_CHAT_QUOTATION_LIST = 'INTERNET_CHAT_QUOTATION_LIST';
